import { handleize } from '../../helpers/dom'

export function ProductPagePromo() {
  const settings = window.productCardCalloutConfig
  if (!settings || settings.length <= 0 || !settings[0].enable || !settings[0].text) {
    return <></>
  }

  const productCollections = productState?.initProduct?.collections || []
  const isMetafield = settings.some((item) => item.isMetafield)
  const callOutConfigs = settings.sort((a, b) => a.priority - b.priority)

  const firstSettings = isMetafield
    ? callOutConfigs.find((item) =>
      item.collections?.some((name) =>
        productCollections.some((item) => handleize(item.title) === handleize(name))
      )
    )
    : callOutConfigs[0]

  if (!firstSettings || !firstSettings.pdp) {
    return <></>
  }

  const { backgroundColor, color } = firstSettings.pdp
  if (!backgroundColor || !color) {
    console.warn('Global callout colors undefined')
    return <></>
  }

  return (
    <div
      style={{ backgroundColor, color }}
      className={firstSettings.timer ? 'mb-6 md:mb-0 md:mt-6 rounded px-5 py-[7px] lg:py-2 font-sans text-sm' : 'mt-6 rounded px-5 py-4 font-sans text-sm' }
    >
      <span className={firstSettings.timer ? 'flex items-center flex-wrap justify-center lg:justify-start gap-x-3 gap-y-0' : '' }>{firstSettings.text} {firstSettings.timer && (<span className={`gta-block__root ${firstSettings.timer}`}></span>)}</span>
    </div>
  )
}
